import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useParams } from 'react-router-dom';
import Navbar from '../../Navbar/Navbar';
import Footer from '../../Footer/Footer';
import BlogCTA from '../BlogCTA/BlogCTA';
import BlogActionCTA from '../BlogActionCTA/BlogActionCTA';
import RelatedStories from './RelatedStories';
import BlogArticle from './BlogArticle';
import useBlogDetails from '../useBlogDetails';
import { BlogDetailsSkeleton, RelatedSkeleton } from '../BlogSkeleton';
import './BlogDetails.css';

const BlogDetails = () => {
  const { slug } = useParams();
  const { post, related, loading, relatedLoading, error } = useBlogDetails(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <div>
      <Helmet>
        <title>{post?.title || 'Blog'}</title>
        <meta name="description" content={post?.summary || 'Sonaroid blog article'} />
        {post?.slug ? (
          <link rel="canonical" href={`https://sonaroid.io/blog/${post.slug}`} />
        ) : null}
      </Helmet>
      <Navbar
        background="#FFFFFF"
        alternative="active"
        bottomBorder="1px solid #ECE9E4"
      />

      <article className="blog-details">
        <div className="page-container">
          <nav className="blog-breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <Link to="/blog">Blog</Link>
            <span>/</span>
            <span className="blog-breadcrumb-current">
              {loading ? 'Loading...' : post?.title || 'Post'}
            </span>
          </nav>

          {loading ? (
            <BlogDetailsSkeleton />
          ) : error || !post ? (
            <p className="blog-error-state">
              Unable to load this blog post.{' '}
              <Link to="/blog">Back to blog</Link>
            </p>
          ) : (
            <BlogArticle post={post} />
          )}
        </div>
      </article>

      {relatedLoading ? (
        <section className="related-stories">
          <div className="page-container">
            <h2>Related Stories</h2>
            <RelatedSkeleton />
          </div>
        </section>
      ) : (
        <RelatedStories posts={related} />
      )}
      <BlogCTA />
      <BlogActionCTA title="Let’s create magic together" />
      <Footer />
    </div>
  );
};

export default BlogDetails;
